import React from 'react'
import { AppSvg, IconWithBackground, NavMenuItem, newIcons } from '@web/walter-ui-kit'
import { useLocale } from '@web/walter-lib/locale'

import s from './style.module.css'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import { useCommonCMSConfig } from '~api'

interface Props {
    isIcon?: boolean
}

function LocaleButton({ isIcon }: Props) {
    const { locales = [] } = useCommonCMSConfig().data ?? {}
    const { show: openLocaleModal } = useModal(ModalTypes.locale)
    const { locale } = useLocale()
    const currentLocale = locales.find(l => l.code === locale) || locales[0]

    if (locales.length < 2) {
        return null
    }

    if (isIcon) {
        return (
            <div onClick={() => openLocaleModal()} className={s.iconButton} data-pointer="locale_button">
                <IconWithBackground
                    size={40}
                    type="default"
                    icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Language} />}
                />
            </div>
        )
    }

    return (
        <NavMenuItem
            dataPointer="locale_button"
            icon={<AppSvg path="new-icons" svgName={newIcons.ic24Language} size={24} />}
            type="button"
            onClick={() => openLocaleModal()}
        >
            {currentLocale.title}
        </NavMenuItem>
    )
}

export default LocaleButton
